import React from "react";
import { useSelector } from "react-redux";
import {
    getDisplayParticipantCounterNumber,
    getDisplayAddAnotherButton,
} from "@qgiv/p2p-registration";
import { ThemeType } from "../../../../../redux/constants";
import {
    selectAllRegistration,
    addRegistration,
} from "../../../../../redux/slices/registrationSlice";
import {
    selectHasParentRegistration,
    setAppShowRegistrationRole,
    setAppShowRemainingForm,
} from "../../../../../redux/slices/appSettingsSlice";
import { selectIsCms } from "../../../../../redux/slices/configSlice";
import {
    selectAllP2pSettings,
    selectAllowSubRegistrantToChangeRegRoleBasedOnEnabledTeams,
    selectBaseUrl,
} from "../../../../../redux/slices/p2pSettingsSlice";
import { selectAllCategories } from "../../../../../redux/slices/categoriesSlice";
import { selectThemeSettings } from "../../../../../redux/slices/cmsSettingsSlice";
import ParticipantCounter from "./ParticipantCounter";

const ConnectedParticipantCounter = () => {
    const hasParentRegistration = useSelector(selectHasParentRegistration);
    const { registrations = [], addAdditionalParticipantDisabled = false } =
        useSelector(selectAllRegistration);

    const themeSettings = useSelector((state) =>
        selectThemeSettings(ThemeType.SUMMARY, state),
    );

    const isCms = useSelector(selectIsCms);

    const {
        p2pActionSettings: { addParticipantLinkLabel = "Add Another" },
        p2pRegistration: { regSubsectionHeading = "Registration" },
    } = themeSettings;

    const { additionalRegistrants } = useSelector(selectAllP2pSettings);
    const categories = useSelector(selectAllCategories);
    const baseUrl = useSelector(selectBaseUrl);
    const allowSubRegistrantToChangeRegRole = useSelector(
        selectAllowSubRegistrantToChangeRegRoleBasedOnEnabledTeams,
    );

    const primaryRegistration = registrations[0];

    const participants = registrations?.filter(
        (registration) => Object.keys(registration).length > 0,
    )?.length;

    const displayParticipantCounterNumber = getDisplayParticipantCounterNumber(
        categories,
        additionalRegistrants,
        hasParentRegistration,
    );

    const displayAddAnotherButton = getDisplayAddAnotherButton(
        additionalRegistrants,
        hasParentRegistration,
        addAdditionalParticipantDisabled,
    );

    const addAdditionalAriaLabel = `${addParticipantLinkLabel} ${regSubsectionHeading}`;

    const participantCounterProps = {
        addAdditionalAriaLabel,
        addParticipantLinkLabel,
        addRegistration,
        allowSubRegistrantToChangeRegRole,
        baseUrl,
        displayParticipantCounterNumber,
        displayAddAnotherButton,
        isCms,
        participants,
        primaryRegistration,
        regSubsectionHeading,
        setAppShowRegistrationRole,
        setAppShowRemainingForm,
    };

    return <ParticipantCounter {...participantCounterProps} />;
};

export default ConnectedParticipantCounter;
